import ReactQuillCustomJP from "@lhd/components/ReactQuillCustomJP";

import { Form } from "antd";
import ReactQuill from "react-quill";
import { useEffect, useRef, useState } from "react";
import { Styles } from "./styled";
import { AppPartType } from "@lhd/features/Apps/AppForm/types";
import { getConfigAppPartType, trimHTML } from "@lhd/features/Apps/utils";
import { ROW_HEIGHT } from "@lhd/components/Table/hook";
import { getRuleValidation } from "@lhd/components/CloneApp/fieldUtils";

interface IProps {
  namePath: string | string[];
  item: AppPartType;
  parentItem?: AppPartType;
  onChange?: (state: string) => void;
  isDisabled?: boolean;
  isTable?: boolean;
  preview?: boolean;
  isPDF?: boolean;
  styleColor?: React.CSSProperties;
}

const RichText = (props: IProps) => {
  const {
    namePath,
    item,
    onChange,
    isDisabled,
    preview,
    styleColor = {},
    isTable,
  } = props;
  const [isFocus, setIsFocus] = useState(false);
  const refHasFocus = useRef(false);
  const form = Form.useFormInstance();
  const minHeight = isDisabled ? 0 : item.item_config_data.h * ROW_HEIGHT - 30;
  const idRichText = namePath + "-rich_text";
  const quillRef = useRef<ReactQuill>();
  const containerRef = useRef<HTMLDivElement>(null);
  const handleRemoveEmptyStringRich = (html: string) => {
    if (html && !isFocus) {
      const newValue = trimHTML(html);
      if (html === newValue || html === "<p><br></p>") return;
      quillRef.current?.editor?.clipboard.dangerouslyPasteHTML(newValue);
      quillRef.current?.editor?.blur();
      onChange && onChange(newValue);
    }
  };

  useEffect(() => {
    const handleSetFocus = (e: MouseEvent) => {
      const htmlElememt = e.target as HTMLElement;
      const container = htmlElememt.closest(`#${CSS.escape(idRichText)}`);
      setIsFocus(!!container);
    };
    if (isFocus) window.addEventListener("click", handleSetFocus);
    return () => {
      window.removeEventListener("click", handleSetFocus);
    };
  }, [isFocus]);

  useEffect(() => {
    if (!isFocus) {
      handleRemoveEmptyStringRich(
        quillRef.current?.props.value?.toString() || "",
      );
    }
  }, [isFocus]);
  useEffect(() => {
    if (containerRef.current && quillRef.current) {
      const toolbar = containerRef.current.querySelector(
        ".ql-toolbar",
      ) as HTMLElement;
      const heightToolbar = toolbar?.offsetHeight || 60;
      const container = quillRef.current.editingArea as HTMLDivElement;
      if (container) {
        container.style.minHeight = minHeight - heightToolbar + "px";
      }
    }
  }, [containerRef.current, quillRef.current, isDisabled]);

  const isShowRawValue = isTable && isDisabled;
  const value = form.getFieldValue(namePath);
  if (isShowRawValue) {
    return <div> {value}</div>;
  }
  return (
    <Styles
      id={idRichText}
      onClick={() => {
        refHasFocus.current && setIsFocus(true);
      }}
      ref={containerRef}
      color={styleColor?.color}
      background={styleColor?.background}
    >
      <Form.Item
        name={namePath}
        className="container_rich-text"
        rules={[
          ...getRuleValidation(item),
          () => ({
            validator(_, value) {
              if (
                item.is_required_field &&
                value?.blocks?.filter(
                  (block: any) => block.text !== "" && block.text !== "\n",
                )?.length === 0
              ) {
                return Promise.reject(
                  new Error("整数で指定のフィルードです。ご確認ください。"),
                );
              }
              return Promise.resolve();
            },
          }),
        ]}
      >
        <ReactQuillCustomJP
          style={{
            ...styleColor,
          }}
          quillRef={quillRef}
          onFocus={() => (refHasFocus.current = true)}
          readOnly={!!isDisabled || preview}
          onChange={(state) => {
            onChange && onChange(state);
          }}
        />
      </Form.Item>
    </Styles>
  );
};
export default RichText;
